import { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './Checkbox.module.css';

const Checkbox = forwardRef(({
  label,
  error,
  className = '',
  id,
  ...props
}, ref) => {
  const checkboxId = id;
  const hasError = Boolean(error);

  const containerClasses = classNames(styles.container, className);

  return (
    <div>
      <div className={containerClasses}>
        <input
          ref={ref}
          type="checkbox"
          id={checkboxId}
          className={styles.checkbox}
          aria-invalid={hasError}
          aria-describedby={hasError ? `${checkboxId}-error` : undefined}
          {...props}
        />
        {label && (
          <label htmlFor={checkboxId} className={styles.label}>
            {label}
          </label>
        )}
      </div>
      {hasError && error && (
        <p id={`${checkboxId}-error`} className={styles.error} role="alert">
          {error}
        </p>
      )}
    </div>
  );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
